export const EVENT_BUS_SESSION_ACTIONS_CHANGED = 'gd.session.actions:change'
